export default __webpack_public_path__ + "static/media/Short Strangle.c52e23f8.svg";